"use strict";

exports.__esModule = true;
exports.TYPE = exports.PREFIX = exports.INTERNAL_TYPE = exports.ALIGN = void 0;
var ALIGN = {
  start: 'start',
  center: 'center',
  end: 'end',
  justify: 'justify'
};
exports.ALIGN = ALIGN;
var INTERNAL_TYPE = {
  minimal: '_minimal',
  none: '',
  pills: '_pills',
  tabs: '_tabs'
};
exports.INTERNAL_TYPE = INTERNAL_TYPE;
var PREFIX = {
  secondary: 'Secondary',
  primary: 'Primary'
};
exports.PREFIX = PREFIX;
var TYPE = {
  pills: 'pills',
  tabs: 'tabs'
};
exports.TYPE = TYPE;